<template lang="pug">
el-form-item
  el-upload(
    :class='[baseClass, ratioClass, typeClass]',
    action='/api/v2/util/uploader',
    name='files',
    :show-file-list="false",
    :on-success='handleUploadSuccess',
    :before-upload='beforeUpload')
    template(v-if='imageUrl')
      img(:src='file.uri')
    template(v-else)
      .func
        i.icon.el-icon-plus
    .el-upload__tip(slot="tip")
      p
        | jpg/png/gif 500kb以下 : 推奨サイズ 16:9の画像
        br
        | ( 縦横比の異なる画像も登録可能ですが表示する際にデザインが崩れたり画像が見切れる場合などがあります )
      template(v-if='imageUrl')
        i.icon.el-icon-delete(@click='deleteImage')
</template>

<script>
export default {
  name: 'ElementUploadSingle',
  data () {
    return {
      imageUrl: null,
      baseClass: 'c-uploader',
      ratioClass: 'c-uploader__16_9',
      typeClass: 'c-uploader__16_9'
    }
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    chapter_index: {
      type: Number,
      required: true
    },
    add_item_index: {
      type: Number,
      required: true
    }
  },
  methods: {
    init () {
      this.setImage()
    },
    setImage () {
      let data = this.getValue()
      this.imageUrl = data.uri
    },
    handleUploadSuccess (res, file) {
      let data = this.getValue()
      const value = {
        id: res.id,
        uri: res.uri
      }
      data.id = value.id
      data.uri = value.uri
      this.imageUrl = res.uri
    },
    /**
     * @param {Object} file
     * @returns {undefined}
     */
    beforeUpload (file) {
      const isLt500kb = file.size / 1024 / 1024 < 0.5
      if (!/^image\/[jpeg|png|gif|webp]/.test(file.type)) {
        this.$message.error('jpg/png/gifフォーマットの画像を登録してください')
        return false
      }
      if (!isLt500kb) {
        this.$message.error('500kb以下の画像ファイルを登録してください')
        return false
      }
      return true
    },
    deleteImage () {
      let data = this.getValue()
      data.id = null
      data.uri = null
      this.imageUrl = null
    },
    getValue () {
      return this.form.chapters[this.chapter_index].additional_items[this.add_item_index]
    }
  },
  watch: {
    form (newValue, oldValue) {
      this.setImage()
    }
  },
  created () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Element/Upload/SingleForStories/index.vue